import { CompassCardUI } from '@scale/compass-ui/types';
import {
  CDSDownloadResponseCardShared,
  type CDSDownloadResponseSchemaType,
  type CDSDownloadResponseContext,
  CDS_DOWNLOAD_RESPONSE,
} from '@scale/genai-compass-shared/cards/cds_download_response';
import CDSResponseDownloadCardComponent from './CDSResponseCardComponent';

const defaultContext: CDSDownloadResponseContext = {
  cardType: CDS_DOWNLOAD_RESPONSE,
  jsonataExpression: `(
  /* Passing in $ as the JSONata expression returns the entire response object*/
  $
)`,
  projectId: '683e729ecaf6d16374e6fc5b', // Default project ID - can be overridden in UI
};

export const CDSResponseDownloadCardInfo: CompassCardUI<CDSDownloadResponseSchemaType> = {
  ...CDSDownloadResponseCardShared,
  title: 'Download CDS Response for Attempt',
  icon: 'file-import',
  toolTip: 'Download the response from the CDS for the given attempt',
  defaultContext,
  ownerTeam: 'Connectivity',
  isAdvanced: true,
  legacyComponent: CDSResponseDownloadCardComponent,
};
